const data = {
  heading: 'Job-specific Cover Letter',
  subHeading:
    'Please add the job description of the position you are applying for:',
};

export default data;
